import Vue from 'vue'
import axios from 'axios'

// axios.defaults.baseURL = 'http://parse.vidowncdn.top/naranzug/'
axios.defaults.baseURL = 'https://api.ip008.com/naranzug/'
axios.defaults.withCredentials = true
Vue.prototype.$ajax = axios



// WEBPACK FOOTER //
// ./src/axios/index.js